'use client'

import { useState } from 'react'
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { SelectBox } from "@/components/holders/SelectBox";

export default function AddInvoiceRowFree({...props}) {
const [selectedVat, setSelectedVat] = useState(props.selectedVat);
const [invoiceRow, setInvoiceRow] = useState(props?.invoiceRow);
const filterNonNumeric =(evt, max) => {
    
    if(evt.which > 41 && evt.which != 190 ) {
        if(evt.which == 173) {
            if(evt.target.value.length == 0) {
                evt.target.value = '-';
                evt.preventDefault();
                return;
            }
            if(Math. abs(evt.target.value) > 0 ) {
                evt.target.value = 0-evt.target.value;
            } else {
                if(evt.target.value.substr(0,1) == '-') {
                    evt.target.value = "";
                }
            }
            evt.preventDefault();
            return;     
        }
        if ((evt.which < 48 || evt.which > 57) )
        {
            evt.preventDefault();
        }
        if(evt.target.attributes.getNamedItem("max")) {
            let maxValue = evt.target.attributes.getNamedItem("max").value;
            let newValue = evt.target.value+""+evt.key;
            if( parseFloat(newValue) > parseFloat(maxValue) ) {
             evt.preventDefault();   
            }
        }
    }    
}

const onFocusOut= (event, name) => {
  let keyName = event.target.name;
  let val = event.target.value;
  props.invoiceRow.setValue(keyName,val);
  props.updateInvoiceRowHandler(props.invoiceRow);

}


const onCLoseSelectTimeRegHandler = (event) => {
    if(props?.updateInvoiceRowHandler) {
        props.updateInvoiceRowHandler(event.data.invoiceRow);
    
    }
  }


   const setValueVatRate= (name, selected) => {
    props.invoiceRow.setVatRate(selected);
    props.updateInvoiceRowHandler(props.invoiceRow);
    setSelectedVat(selected);
   }

  return (
<>
          <div className="space-y-8 border-b border-gray-900/10 ">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Omschrijving
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
              
                                 <textarea
          id="description"
          name="description"
          onBlur={(event) => onFocusOut(event, name)}
          rows={4}
          className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
          defaultValue={''}
        />
              </div>
            </div>
           </div>

          <div className="space-y-8 border-b border-gray-900/10 ">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
          
      <label htmlFor="phone-number" className="block text-sm font-medium leading-6 text-gray-900">
        Aantal
      </label>
      <div className="relative mt-2 rounded-md shadow-sm">

        <input
          id="amount"
          name="amount"
          onBlur={(event) => onFocusOut(event, name)}
          type="text"
          max = "9999"
          onKeyDown={(event,max) => filterNonNumeric(event, max)}
          placeholder=""
          className="block w-full rounded-md border-0 py-1.5 pl-16 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>

</div>          
          </div>


          <div className="space-y-8 border-b border-gray-900/10 ">
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
          
      <label htmlFor="phone-number" className="block text-sm font-medium leading-6 text-gray-900">
        Prijs
      </label>
      <div className="relative mt-2 rounded-md shadow-sm">

        <input
          id="price"
          name="price"
          onBlur={(event) => onFocusOut(event, name)}
          type="text"
          max="1000000"
          filtertype="price"
          onKeyDown={(event,max) => filterNonNumeric(event, max)}
          placeholder=""
          className="block w-full rounded-md border-0 py-1.5 pl-16 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
        />
      </div>

</div>          
          </div>
          
            <div className="space-y-8 border-b border-gray-900/10 ">
          
            <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 sm:py-6">
              <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                BTW
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">
                <input type="hidden" name="vatrate_percentage" defaultValue={selectedVat.percentage} />
                <input type="hidden" name="vatrate_key" defaultValue={selectedVat.key} />
                <SelectBox className="" label="" name="customer" data={props.vatrates} selected={selectedVat} boxfield="name" placeHolder="Selecteer een BTW tarief" changeEvent={(name, val) => setValueVatRate(name,val)}/>                
              </div>
            </div>
           </div>
          

</>

  )
}
